import { render, staticRenderFns } from "./listSecond.vue?vue&type=template&id=a66b7918&scoped=true"
import script from "./listSecond.vue?vue&type=script&lang=js"
export * from "./listSecond.vue?vue&type=script&lang=js"
import style0 from "./listSecond.vue?vue&type=style&index=0&id=a66b7918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66b7918",
  null
  
)

export default component.exports